(function () {
  'use strict';

  var POLL_MS = 100;
  var MAX_WAIT_MS = 30000;
  var elapsed = 0;
  var countEl = document.querySelector('.product-star-rating__count');
  var ratingEl = document.querySelector('.product-star-rating');

  if (!ratingEl || !countEl) {
    return;
  }

  // Smooth scroll to reviews on click
  ratingEl.addEventListener('click', function () {
    var reviewsTabBtn = document.querySelector('#bc-ab-tab-reviews');
    if (reviewsTabBtn) {
      reviewsTabBtn.click();
      reviewsTabBtn.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      var reviewsSection = document.querySelector('#judgeme_product_reviews');
      if (reviewsSection) {
        reviewsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  });

  // Poll for Judge.me widget review count
  function getReviewCount() {
    try {
      var widget = Object.values(window.jdgm?.data?.reviewWidget || {})[0];
      return widget?.number_of_reviews || 0;
    } catch (e) {
      return 0;
    }
  }

  function updateReviewCount() {
    var reviewCount = getReviewCount();

    if (reviewCount > 0) {
      countEl.textContent = '(' + reviewCount + ' reviews)';
    } else {
      elapsed += POLL_MS;
      if (elapsed < MAX_WAIT_MS) {
        setTimeout(updateReviewCount, POLL_MS);
      }
    }
  }

  // Start polling
  updateReviewCount();
})();
